import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import StepProgressBar from '../../components/StepProgressBar/StepProgressBar';
import { dataStepProgress } from './data';
import Layout from '../../components/Layout/Layout';
import { LoadSpinner } from '../../components/Utils';

const createQuiz = 'Crear Evaluación';

const CreateTest = ({ history, ongoingRequest }) => (
  <Layout>
    <Container fluid>
      <Row>
        <Col role="main">
          {ongoingRequest.editQuiz ||
            (ongoingRequest.updateThirdStep && <LoadSpinner />)}
          <div className="section">
            <StepProgressBar
              history={history}
              steps={dataStepProgress}
              title={createQuiz}
            />
          </div>
        </Col>
      </Row>
    </Container>
  </Layout>
);

const mapStateToProps = state => {
  const { ongoingRequest } = state.test;
  return {
    ongoingRequest
  };
};

export default connect(mapStateToProps)(CreateTest);
